import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';

import { wrapper, paper, row, text } from './UploadPlaceholder.less';

const UploadPlaceholder = ({ onClick, locale }) => (
  <div className={wrapper}>
    <Paper circle zDepth={0} className={paper} onClick={onClick}>
      <Row middle="xs" center="xs" className={row}>
        <Col xs={12}>
          <p className={text}>{locale('profile.avatar.choose')}</p>
        </Col>
      </Row>
    </Paper>
  </div>
);

UploadPlaceholder.propTypes = {
  onClick: PropTypes.func.isRequired,
  locale: PropTypes.func,
};

export default UploadPlaceholder;
